export default __webpack_public_path__ + "static/media/hht1_ani_13.bce69ca3.png";